import React, { useRef, useEffect } from 'react';
import BrewmasterMessage from './BrewmasterMessage';

function BrewmasterChat({ messages, children }) {
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages.length]);

  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-2">
      {messages.map((msg, i) => (
        <BrewmasterMessage key={i} role={msg.role} content={msg.content} />
      ))}
      {children}
      <div ref={bottomRef} />
    </div>
  );
}

export default BrewmasterChat;
